import { formSchema } from "../../validaciones/validacionNotificaciones";

export const notificacionesSlice = (set,get) => ({
    insertarNotificacion: () => {
        const result = formSchema.safeParse({ ...get().datos });
        if (!result.success) {
            console.log(result.error.errors);
            console.log(result.error.flatten().fieldErrors);
            set({error:result.error.flatten().fieldErrors})
            return;
        }
        else{
            set({error:null})
        }

        if(get().datos.tipo_notificacion == 3 ){
            if (get().datos.id_sucursal == 0) {
                set({error:{id_sucursal:['Selecciona una sucursal']}})
                return;
            }
        }

        if(get().datos.tipo_notificacion == 4 ){
            if (get().datos.id_preferencia == 0) {
                set({error:{id_preferencia:['Selecciona una preferencia']}})
                return;
            }
        }

        if(get().datos.tipo_notificacion == 5 ){
            if (get().datos.tipo_dispositivo == 0) {
                set({error:{tipo_dispositivo:['Selecciona un dispositivo']}})
                return;
            }
        }

        fetch("/p_notificacion_insertar",{
            headers:{"Content-Type": "application/json",},
            method: "POST",
            body: JSON.stringify(get().datos)
        })
        .then((res) => res.json())
        .then((data) => {
            console.log('El dato',data);
            if(data.status == 1){
                // Success
                get().elNavigate(-1);
                get().limpiar();
            }
        })
        .catch((error) => {
            console.log('Error',error);
        });
    },
    obtenerOpcionesNotificacion: async() => {
        await fetch("/p_notificaciones_opciones")
        .then((res) => res.json())
        .then((data) => {
            console.log('Opciones notificacion',data);
            if(data.status === 1){
                set({ 
                    tipos_notificacion: data.data[0].map((item) => { return { value: item.VALOR_TIPO, label: item.NOMBRE_TIPO } }),
                    sucursales: data.data[1].map((item) => { return { value: item.ID_SUC, label: item.NOMBRE_SUCURSAL_SUC } }),
                    preferencias: data.data[2].map((item) => { return { value: item.ID_PRE, label: item.PREFERENCIA } }),
                    dispositivos: data.data[3].map((item) => { return { value: item.ID, label: item.DISPOSITIVO } }),
                    tipo_notificacion: 1,
                })
            }
        });
    }
})